var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLike = function SvgLike(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#14E869",
    d: "M24 2.667H8c-2.213 0-4 1.773-4 3.96v14.546c0 2.187 1.787 3.96 4 3.96h1.013c1.067 0 2.08.414 2.827 1.16l2.28 2.254a2.696 2.696 0 0 0 3.773 0l2.28-2.254A4 4 0 0 1 23 25.133h1c2.213 0 4-1.773 4-3.96V6.627c0-2.187-1.787-3.96-4-3.96m-7.627 17.28c-.2.066-.533.066-.746 0C13.893 19.347 10 16.88 10 12.68c.013-1.853 1.493-3.347 3.333-3.347A3.32 3.32 0 0 1 16 10.667a3.32 3.32 0 0 1 2.667-1.334A3.337 3.337 0 0 1 22 12.68c-.013 4.2-3.893 6.667-5.627 7.267"
  })));
};
export default SvgLike;